/* unplugin-vue-components disabled */import { render } from "./status-bar.vue?vue&type=template&id=e7748504"
import script from "./status-bar.vue?vue&type=script&lang=js"
export * from "./status-bar.vue?vue&type=script&lang=js"

import "./status-bar.vue?vue&type=style&index=0&id=e7748504&lang=scss"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__